import React from "react";
import { ArrowUpRight } from "lucide-react";

export const SubRetreatsGrid = ({ parent, subs, onSelect }) => (
  <section
    data-testid="sub-retreats-section"
    className="mx-auto max-w-[1400px] px-6 pt-20 pb-28 md:px-10 md:pt-28"
  >
    <div className="mb-10 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="overline text-brand-inkSoft">20 curated packages</p>
        <h2 className="font-display mt-3 text-3xl leading-tight md:text-4xl">
          Choose your <em className="italic text-brand-terracotta">{parent.title}</em> chapter
        </h2>
      </div>
      <p className="text-sm text-brand-inkSoft">
        Every option opens directly on <span className="font-medium text-brand-ink">{parent.partner}</span> for booking.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
      {subs.map((s, i) => (
        <a
          key={s.id}
          data-testid={`sub-card-${s.id}`}
          href={s.link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); onSelect(s); }}
          className="group block fade-up"
          style={{ animationDelay: `${Math.min(i, 8) * 50}ms` }}
        >
          <div className="card-img-wrap img-gradient-overlay relative aspect-[4/5] w-full bg-brand-bg2">
            <img src={s.image} alt={s.title} loading="lazy" className="card-img absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-x-0 top-0 z-10 flex justify-between p-4">
              <span className="overline rounded-full bg-white/90 px-3 py-1.5 text-brand-ink" style={{ fontSize: "0.6rem" }}>
                Package {String(i + 1).padStart(2, "0")}
              </span>
              <span className="inline-flex items-center gap-1 rounded-full bg-black/30 px-3 py-1.5 text-[11px] font-medium text-white backdrop-blur-md">
                {s.duration}
              </span>
            </div>
            <div className="absolute inset-x-0 bottom-0 z-10 p-5">
              <h3 className="font-display text-xl leading-tight text-white md:text-2xl">{s.title}</h3>
              <p className="mt-1 text-sm text-white/80">{s.location}</p>
            </div>
          </div>
          <div className="mt-4 flex items-center justify-between px-1">
            <div className="text-sm text-brand-inkSoft">
              <span className="font-medium text-brand-ink">{s.duration}</span>
              <span className="mx-2 text-brand-line">·</span>
              <span>from {s.priceFrom}</span>
            </div>
            <div className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-ink">
              <span data-testid={`sub-partner-${s.id}`} className="link-underline">Book on {s.partner}</span>
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </div>
          </div>
        </a>
      ))}
    </div>
  </section>
);

export default SubRetreatsGrid;
